import React from "react";
import nextId from "react-id-generator";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import {
  instituteLogin,
  requestForgotPassword,
  userLogin,
} from "../../../APIs/PostAPIS";
import { Images } from "../../../Assets/0a-exporter";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import ForgotPassword from "../../Portals/ForgotPassword/ForgotPassword";
import Notification from "../../Portals/Notification/Notification";
import GoogleLoginCustom from "../GoogleLogin/GoogleLogin";
import "./login-component.style.scss";
export default function LoginComponent({
  setMainType,
  modal,
  modalClose,
  indirect,
  openSignUp,
  setFPModal,
}) {
  const context = React.useContext(MainContext);
  const { loginType } = useParams();
  const [emailSent, setEmailSent] = React.useState({
    status: null,
    message: "",
  });
  const [showPassword, setShowPassword] = React.useState(false);
  const [requesting, setRequesting] = React.useState(false);
  const { initialChecking, updateState, routeLink } = context;
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [openFPModal, setOpenFPModal] = React.useState(false);

  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });

  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  const [userDetails, setUserDetails] = React.useState({
    email: "",
    password: "",
    role_type: "",
  });

  const clearNotification = () => {
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      clearTimeout(a);
    }, [3000]);
  };
  const handleLogin = async () => {
    try {
      setLoading(true);
      let res;
      if (loginType === "candidate") {
        res = await userLogin({
          ...userDetails,
          role_type: loginType || indirect,
        });
      } else {
        res = await instituteLogin({
          ...userDetails,
          role_type: loginType || indirect,
        });
      }
      if (res.data.statusCode === 200) {
        updateState("userDetails", null);
        localStorage.setItem("userId", res.data.data._id);
        localStorage.setItem("iSmartID", res.data.data.iSmartID);
        localStorage.setItem("userEmail", res.data.data.email);
        localStorage.setItem("userToken", res.data.token);
        updateState("userType", loginType || indirect);
        initialChecking();
        if (modal) {
          modalClose();
          return;
        }
        if (loginType === "candidate" || indirect === "candidate") {
          if (!routeLink) {
            history.push("/user/list");
          } else {
            history.push(routeLink);
          }
        } else {
          history.push("/institute");
        }
      } else {
        setNotification({
          status: true,
          title: `Wrong Credentials`,
          moreDetails: `Please Try Again`,
        });
        clearNotification();
      }
      setLoading(false);
    } catch (error) {
      setNotification({
        status: true,
        title: `Wrong Credentials`,
        moreDetails: `Please Try Again`,
      });
      clearNotification();
      setLoading(false);
    }
  };
  const forgotPasswordSubmit = async (email) => {
    try {
      setRequesting(true);
      let res = await requestForgotPassword({ email: email });
      if (res.data.statusCode === 200) {
        setEmailSent({
          status: true,
          message: res.data.message,
        });
        setOpenFPModal(false);
        setRequesting(false);
      } else {
        setRequesting(false);
        setEmailSent({
          status: false,
          message: res.data.message,
        });
      }
    } catch (error) {
      setRequesting(false);
      setEmailSent({
        status: false,
        message: "Something went wrong.",
      });
    }
  };
  React.useEffect(() => {
    return () => {
      updateState("routeLink", "");
    };
  }, []);

  React.useEffect(() => {
    if (!modal) return;
    setFPModal(openFPModal);
  }, [openFPModal]);

  React.useEffect(() => {
    if (loginType === "candidate" || indirect === "candidate") {
      setSelectedOption(options[0]);
      setMainType(options[0]);
    } else {
      setSelectedOption(options[1]);
      setMainType(options[1]);
    }
  }, [loginType, indirect]);

  return (
    <div className="login-component-main">
      {openFPModal && (
        <ForgotPassword
          requesting={requesting}
          emailSent={emailSent}
          handleSubmit={forgotPasswordSubmit}
          closeIt={() => setOpenFPModal(false)}
        />
      )}
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <header className="lcm-header">
        <h2>Welcome Back!</h2>
      </header>
      {modal ? (
        <div className="single-option">
          <h6>
            {indirect === "candidate" ? "For Candidates" : "For Institution"}
          </h6>
        </div>
      ) : (
        <div className="lcm-options">
          <div
            className={
              selectedOption.id === "candidate" ? "left-most" : "right-most"
            }
          />
          {options.map((obj) => (
            <h6
              onClick={() => {
                if (modal) return;
                setSelectedOption(obj);
                setMainType(obj);
                history.push(`/login/${obj.id}`);
              }}
              className={obj.id === selectedOption.id ? "selected" : ""}
              key={obj.keyId}
            >
              {obj.text}
            </h6>
          ))}
        </div>
      )}
      {emailSent.status !== null && (
        <div className={`request-info ${!emailSent.status ? "failed" : ""}`}>
          <p>{emailSent.message}</p>
        </div>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
        className="form-login"
      >
        <div className="on-border-input">
          <span>Email ID</span>
          <input
            name="email"
            onChange={(e) =>
              setUserDetails({
                ...userDetails,
                [e.target.name]: e.target.value,
              })
            }
            placeholder="user@gmail.com"
            type="email"
            required
          />
        </div>
        <div className="on-border-input">
          <span>Password</span>
          <div>
            <input
              name="password"
              onChange={(e) =>
                setUserDetails({
                  ...userDetails,
                  [e.target.name]: e.target.value,
                })
              }
              placeholder="*********"
              type={showPassword ? "text" : "password"}
              required
            />
            {/* <button
              onClick={() => setShowPassword(!showPassword)}
              type="button"
            >
              {showPassword ? (
                <img src="https://img.icons8.com/ios/50/000000/visible--v1.png" />
              ) : (
                <img src="https://img.icons8.com/ios/50/000000/hide.png" />
              )}
            </button> */}
          </div>
        </div>
        <div className="passwords-wrapper">
          <p
            className="forgot-password"
            onClick={() => {
              setEmailSent({ status: null, message: "" });
              setOpenFPModal(!openFPModal);
            }}
          >
            Forgot Password?
          </p>
          <p className="show-password">
            <input
              checked={showPassword}
              onChange={(e) => setShowPassword(e.target.checked)}
              type="checkbox"
            />
            Show password
          </p>
        </div>
        <div className="login-button">
          <button
            type="submit"
            className={selectedOption.id === "institution" ? "blue-button" : ""}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </div>
      </form>
      <div className="line-breaker">
        <span />
        <span>
          {modal ? (
            <Link
              onClick={(e) => {
                e.preventDefault();
                openSignUp();
              }}
            >
              Sign up,
            </Link>
          ) : (
            ""
          )}{" "}
          Or login with
        </span>
        <span />
      </div>
      <div className="other-sign-in-option">
        <GoogleLoginCustom />
        <button>
          <img src={Images.facebook} />
        </button>
        <button>
          <img src={Images.linkedLogo} />
        </button>
        {/* {others.map((obj) => (
          <button key={obj.keyId}>
            <img src={obj.icon} />
          </button>
        ))} */}
      </div>
    </div>
  );
}
const options = [
  { keyId: nextId(), id: "candidate", text: "For Candidates" },
  { keyId: nextId(), id: "institution", text: "For Institutes" },
];
const others = [
  { keyId: nextId(), id: "google", icon: Images.google },
  { keyId: nextId(), id: "fb", icon: Images.facebook },
  { keyId: nextId(), id: "linkedIn", icon: Images.linkedLogo },
];
